module.exports = __webpack_public_path__ + "static/img/submit.f82f7bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/submit.png
// module id = pNX/
// module chunks = 1